// extracted by mini-css-extract-plugin
export var formContainer = "_ci-0";
export var message = "_ci-1";